export function initAuctionFilter(formEl, selectedFilterEl) {
    const filtersEls = formEl.querySelectorAll('[data-filter]');
    filtersEls.forEach(filterEl => {
        filterEl.addEventListener('click', (e) => {
            e.preventDefault();
            const dialogEl = formEl.querySelector('[data-filter-dialog="' + filterEl.dataset.filter + '"]');
            if (dialogEl) {
                console.log({ dialogEl })
                $(dialogEl).modal('show');
            }
        });
    });

    const applyFilterBtns = formEl.querySelectorAll('[data-btn-apply-filter]');
    applyFilterBtns.forEach(btnEl => {
        btnEl.addEventListener('click', (e) => {
            e.preventDefault();
            const dialogEl = btnEl.closest('[data-filter-dialog]');
            if (dialogEl) {
                resolveEvent(dialogEl.dataset.filterDialog);
            }
            applyFilter();
        });
    });

    if (selectedFilterEl) {
        const cancelBtns = selectedFilterEl.querySelectorAll('[data-cancel-filter-type]')
        cancelBtns.forEach(btnEl => {
            btnEl.addEventListener('click', (e) => {
                e.preventDefault();

                const filterType = btnEl.dataset.cancelFilterType;
                if (filterType === 'buyNowPrice') {
                    formEl.querySelector('[name="buyNowPriceFrom"]').value = '';
                    formEl.querySelector('[name="buyNowPriceTo"]').value = '';
                } else {
                    formEl.querySelector('[name^="' + filterType + '"][value="' + btnEl.dataset.cancelValue + '"]').removeAttribute('checked');
                }

                applyFilter();
            })
        })
    }

    const sortByEl = formEl.querySelector('[data-sort-by]');
    if (sortByEl) {
        sortByEl.addEventListener('change', (e) => {
            applyFilter();
        })
    }

    function applyFilter() {
        const formData = new FormData(formEl);
        const asString = new URLSearchParams(formData).toString();
        const char = formEl.dataset.auctionFilterUrl.includes('?') ? '&' : '?';
        window.location = formEl.dataset.auctionFilterUrl + char + asString;
    }

    function resolveEvent(type) {
        switch (type) {
            case 'breweries':
            case 'beers':
                sendAnalyticsEvent(type + ': ' + gatherCheckboxes(type));
                break;
            case 'buyNowPrice':
                sendAnalyticsEvent(type + ': ' + gatherRange(type));
                break;
        }
    }

    function gatherCheckboxes(type) {
        return [...formEl.querySelectorAll('[name^="' + type + '"]:checked')].map(i => i.value).join(', ');
    }

    function gatherRange(type) {
        const from = formEl.querySelector('[name="' + type + 'From"]');
        const to = formEl.querySelector('[name="' + type + 'To"]');
        if (from && to) {
            return from.value + '-' + to.value;
        }
    }

    function sendAnalyticsEvent(event) {
        if (window.fathom) {
            window.fathom.trackEvent('auction search - ' + event);
        }
    }
}
